// Scripted pre-qualification flows. Each step: key, question, choices[].
export const FLOWS = {
  business: {
    label: "Business Funding",
    steps: [
      {
        key: "time_in_business",
        question: "Great — let's see how we can help your business. How long has your business been operating?",
        choices: ["Less than 6 months", "6–12 months", "1–2 years", "2+ years"],
      },
      {
        key: "monthly_revenue",
        question: "Roughly what is your average monthly revenue?",
        choices: ["Under $10k", "$10k–$25k", "$25k–$50k", "$50k+"],
      },
      {
        key: "funding_amount",
        question: "How much funding are you looking to access?",
        choices: ["Under $50k", "$50k–$150k", "$150k–$500k", "$500k+"],
      },
      {
        key: "use_of_funds",
        question: "And what would you primarily use the capital for?",
        choices: ["Working capital", "Equipment", "Expansion", "Marketing", "Other"],
      },
    ],
    routeKey: "business",
  },
  real_estate: {
    label: "Real Estate Funding",
    steps: [
      {
        key: "property_type",
        question: "Let's explore your real estate financing. What type of property is this for?",
        choices: ["Residential", "Commercial", "Multi-family", "Land / Development"],
      },
      {
        key: "financing_purpose",
        question: "What are you looking to do?",
        choices: ["Purchase", "Refinance", "Cash-out", "Construction"],
      },
      {
        key: "financing_amount",
        question: "Approximately how much financing are you seeking?",
        choices: ["Under $250k", "$250k–$1M", "$1M–$5M", "$5M+"],
      },
      {
        key: "timeline",
        question: "What's your ideal timeline?",
        choices: ["As soon as possible", "1–3 months", "3–6 months", "Just exploring"],
      },
    ],
    routeKey: "real_estate",
  },
};

export const QUICK_ACTIONS = [
  { id: "business", label: "Business Funding" },
  { id: "real_estate", label: "Real Estate Funding" },
  { id: "general", label: "General Question" },
  { id: "advisor", label: "Speak With an Advisor" },
];
